__turbopack_context__.v({
  "content": "rC1r_a_content",
  "introduction": "rC1r_a_introduction",
  "root": "rC1r_a_root",
});
